module.exports = __webpack_public_path__ + "img/home-modern-bridesman.8cffb7b7.jpg";